import gql from 'graphql-tag';

export const GET_ALLOWED_COB_LIST = gql`
  {
    allowedBusinessAreas {
      dcName
      dcVtweg
      divisionName
      divisionSpart
    }
  }
`;
